import * as React from "react";
const SvgMomentumReversalsBottoming = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M20.0955 28.0083C20.5905 28.4483 21.3426 28.4262 21.8108 27.9579L34.4986 15.2701V23.5068C34.4986 24.1975 35.0586 24.7575 35.7493 24.7575C36.4401 24.7575 37 24.1975 37 23.5068V12.2507C37 11.5599 36.4401 11 35.7493 11H24.4932C23.8025 11 23.2425 11.5599 23.2425 12.2507C23.2425 12.9414 23.8025 13.5013 24.4932 13.5013H32.7299L20.8759 25.3553L5.0816 11.3159C4.56534 10.857 3.77482 10.9035 3.31592 11.4197C2.85703 11.936 2.90353 12.7265 3.41979 13.1854L20.0955 28.0083Z"
}));
export default SvgMomentumReversalsBottoming;
